export default __webpack_public_path__ + "static/media/07-Tim.f4f5ea05.png";